'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData from "./app.data.-App-Document-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentData$PurchaseOrder$() {
}
export { $c_Lapp_data_AppDocumentData$PurchaseOrder$ as $c_Lapp_data_AppDocumentData$PurchaseOrder$ };
$p = $c_Lapp_data_AppDocumentData$PurchaseOrder$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentData$PurchaseOrder$;
/** @constructor */
function $h_Lapp_data_AppDocumentData$PurchaseOrder$() {
}
export { $h_Lapp_data_AppDocumentData$PurchaseOrder$ as $h_Lapp_data_AppDocumentData$PurchaseOrder$ };
$h_Lapp_data_AppDocumentData$PurchaseOrder$.prototype = $p;
$p.n = (function() {
  return "PurchaseOrder";
});
$p.bK9 = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData.$c_Lapp_data_AppDocumentData$PurchaseOrder(x$0.e(0));
});
$p.U = (function(p) {
  return this.bK9(p);
});
var $d_Lapp_data_AppDocumentData$PurchaseOrder$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$PurchaseOrder$, "app.data.AppDocumentData$PurchaseOrder$", ({
  zO: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentData$PurchaseOrder$ as $d_Lapp_data_AppDocumentData$PurchaseOrder$ };
var $n_Lapp_data_AppDocumentData$PurchaseOrder$;
function $m_Lapp_data_AppDocumentData$PurchaseOrder$() {
  if ((!$n_Lapp_data_AppDocumentData$PurchaseOrder$)) {
    $n_Lapp_data_AppDocumentData$PurchaseOrder$ = new $c_Lapp_data_AppDocumentData$PurchaseOrder$();
  }
  return $n_Lapp_data_AppDocumentData$PurchaseOrder$;
}
export { $m_Lapp_data_AppDocumentData$PurchaseOrder$ as $m_Lapp_data_AppDocumentData$PurchaseOrder$ };
//# sourceMappingURL=app.data.-App-Document-Data$-Purchase-Order$.js.map
